var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vg-field',_vm._g(_vm._b({class:{disabled: _vm.disabled},attrs:{"label":_vm.label,"placeholder":`请输入${_vm.label}`,"disable":_vm.disabled,"value":_vm.value,"type":"textarea","autosize":"","rows":"1"},on:{"input":_vm.input}},'vg-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }